import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=f173dd86&scoped=true&"
import script from "./appointment.vue?vue&type=script&lang=js&"
export * from "./appointment.vue?vue&type=script&lang=js&"
import style0 from "./appointment.vue?vue&type=style&index=0&id=f173dd86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f173dd86",
  null
  
)

export default component.exports